import AdditionalInfoInput from './AdditionalInfoInput.component';

export default AdditionalInfoInput;
